import React from 'react'
import MidView from './containers/TheContent';
import DashboardHeader from './Dash_header';
import DashFooter from './DashFooter';
import Sidebar from './Sidebar';

export default function Layout() {
    return (
    <div>
        <Sidebar />
        <div className="wrapper d-flex flex-column min-vh-100">
            <DashboardHeader />
            <div className="body flex-grow-1">
                <MidView />
            </div>
            <DashFooter />
        </div>
    </div>
    )
}